/* eslint-disable vue/multi-word-component-names */
/* eslint-disable vue/component-definition-name-casing */
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.component('multiselect', Multiselect)
